import { observer } from 'mobx-react'
import React, { useContext } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'

import { UserStoreContext } from '@/stores/UserStore'
import { CookieHubConfig } from '@/utils/cookiehubConfig'
import { joinClassNames } from '@/utils/helpers'

/**
 * TermsAndConditions
 */
const TermsAndConditions = observer(() => {
  // Context
  const { isAuthenticated, isDealerService, isDealerUser } = useContext(UserStoreContext)

  return (
    <>
      <Helmet script={[...CookieHubConfig()]} />
      <div
        className={joinClassNames(
          'bg-background mt-6 flex h-full w-full flex-col overflow-y-auto pb-12',
          !isAuthenticated && 'mt-32',
        )}
      >
        <main className="mx-auto flex w-full max-w-7xl grow flex-col px-4 sm:px-6 lg:px-8">
          <div className="mb-4 flex w-full flex-col items-center gap-4">
            <span className="text-3xl font-bold">Terms and Conditions</span>
            {!isAuthenticated && (
              <Link
                to="/login"
                className="text-sm font-semibold uppercase leading-[14px] tracking-[1.5px] text-blue-800 hover:text-blue-900"
              >
                Log In
              </Link>
            )}
          </div>

          {isDealerUser && (
            <p className="text-md">
              {isDealerService
                ? 'By registering and using the WARP Platform, You acknowledge and agree that the queries, questions, design, layout, and organization that are made and presented to You by the WARP Platform as well as the compilation of information that is input by You into the WARP Platform (collectively, "Compilations") are proprietary, confidential, and trade secret of Warranty Processing Company, Inc. You agree not to distribute or otherwise disclose the Compilations to another party or another person, and You agree that any disclosure of the Compilations to another party or another person is prohibited and shall cause irreparable harm to Warranty Processing Company, Inc.'
                : 'You hereby represent that you have authority on behalf of Dealer and, by Dealer registering and using the WARP Platform, You acknowledge and agree that the queries, questions, design, layout, and organization that are made and presented to Dealer and its users by the WARP Platform as well as the compilation of information that is input by Dealer into the WARP Platform (collectively, "Compilations") are proprietary, confidential, and trade secret of Warranty Processing Company, Inc. You and Dealer agree not to distribute or otherwise disclose the Compilations to another party or another person, and You and Dealer agree that any disclosure of the Compilations to another party or another person is prohibited and shall cause irreparable harm to Warranty Processing Company, Inc.'}
            </p>
          )}
          <span className="mt-4 text-lg font-bold">
            SMS Messaging for Multi-Factor Authentication
          </span>
          <ol className="text-md mt-2">
            <li className="list-inside list-decimal">
              You can opt-in to SMS messaging for MFA verification codes in your Profile Page.
            </li>
            <li className="list-inside list-decimal">
              You can cancel the SMS service at any time. Just text &quot;STOP&quot; to the short
              code. After you send the SMS message &quot;STOP&quot; to us, we will send you an SMS
              message to confirm that you have been unsubscribed. After this, you will no longer
              receive SMS messages from us. If you want to join again, just sign up as you did the
              first time and we will start sending SMS messages to you again.
            </li>
            <li className="list-inside list-decimal">
              If you are experiencing issues with the messaging program you can reply with the
              keyword HELP for more assistance.
            </li>
            <li className="list-inside list-decimal">
              Carriers are not liable for delayed or undelivered messages.
            </li>
            <li className="list-inside list-decimal">
              As always, message and data rates may apply for any messages sent to you from us and
              to us from you. If you have any questions about your text plan or data plan, it is
              best to contact your wireless provider.
            </li>
            <li className="list-inside list-decimal">
              If you have any questions regarding privacy, please read our{' '}
              <Link className="underline" to="/privacy-policy">
                privacy policy
              </Link>
              .
            </li>
          </ol>
        </main>
      </div>
    </>
  )
})

export default TermsAndConditions
